module.exports = __webpack_public_path__ + "img/piechart.d288d8f3.svg";